import script from "./GoogleAuthenticatorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleAuthenticatorView.vue?vue&type=script&setup=true&lang=ts"

import "./GoogleAuthenticatorView.vue?vue&type=style&index=0&id=4d7ffe6c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7ffe6c"]])

export default __exports__